import React from 'react';

export default function HistoricoDemanda({ historico }) {
  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusIcon = (status) => {
    const statusNome = status?.nome?.toLowerCase() || '';
    switch (statusNome) {
      case 'recebida':
      case 'nova':
        return 'fas fa-inbox';
      case 'encaminhada':
        return 'fas fa-share';
      case 'concluída':
      case 'finalizada':
        return 'fas fa-check-circle';
      default:
        return 'fas fa-circle';
    }
  };

  const getStatusClass = (status) => {
    const statusNome = status?.nome?.toLowerCase() || '';
    switch (statusNome) {
      case 'recebida':
      case 'nova':
        return 'historico-nova';
      case 'encaminhada':
        return 'historico-encaminhada';
      case 'concluída':
      case 'finalizada':
        return 'historico-concluida';
      default:
        return 'historico-default';
    }
  };

  if (!historico || historico.length === 0) {
    return (
      <div className="historico-empty">
        <p>Nenhum histórico disponível.</p>
      </div>
    );
  }

  return (
    <div className="historico-demanda">
      <div className="historico-timeline">
        {historico.map((item, index) => (
          <div key={item.id} className={`historico-item ${getStatusClass(item.status_info)}`}>
            <div className="historico-icon">
              <i className={getStatusIcon(item.status_info)}></i>
            </div>
            <div className="historico-content">
              <div className="historico-header">
                <h5>{item.status_info?.nome || 'Status não definido'}</h5>
                <span className="historico-data">{formatarData(item.criado_em)}</span>
              </div>
              <div className="historico-details">
                {item.funcionario_info && (
                  <p><strong>Funcionário:</strong> {item.funcionario_info.nome}</p>
                )}
                {item.funcionario_resp_info && (
                  <p><strong>Responsável:</strong> {item.funcionario_resp_info.nome}</p>
                )}
                {item.setor_info && (
                  <p><strong>Setor:</strong> {item.setor_info.descricao}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}